import { ref, reactive } from "vue"

const lastMealUpdated = ref({})
const lastMealDeleted = ref({})
const lastMealAdded = ref([])

export { lastMealUpdated, lastMealDeleted, lastMealAdded }
